import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import StudentStudyQualityTable from './StudentStudyQualityTable';
import { StudentStudyQualityListService } from '../../services/CustomerSuccessKpiListService';
import { get } from 'lodash';

class StudentStudyQualityDetailTableContainer extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['segment', 'distributor']).isRequired,
    typeId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    StudentStudyQualityListService.load();
  }

  render() {
    return (
      <StudentStudyQualityTable
        loading={
          StudentStudyQualityListService.fetchCurrent.fetching || StudentStudyQualityListService.fetchPrevious.fetching
        }
        values={toJS(StudentStudyQualityListService.getCompaniesByType(this.props.type, this.props.typeId))}
        feedbackColorRender={StudentStudyQualityListService.getFeedbackColor}
        onSelect={(row) =>
          browserHistory.push(
            `/kpis/customer-success/${this.props.type}/${get(this.props, 'typeId', 'NA')}/company/${row.id}/details`
          )
        }
        formatter={StudentStudyQualityListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentStudyQualityDetailTableContainer);
